export default {
  profileSelector: {
    activeProfile: 'Aktivní'
  }
}
